<template>
  <component
    :is="component"
    v-if="cups.length > 0"
    :value="cups"
    :short-name="shortName"
    v-bind="$attrs"
  />
</template>
<script>
import AppShowEventCups from "@/components/elements/AppShows/event/AppShowEventCups.vue";
import AppShowEventCupSeasons from "@/components/elements/AppShows/event/AppShowEventCupSeasons.vue";
import { uniq } from "lodash-es";
export default {
  name: "AppShowEventCupComponent",
  props: {
    event: {
      type: Object,
      default: () => ({ cups: [] })
    },
    shortName: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      component: null,
      cups: []
    };
  },
  fragments: {
    cups: AppShowEventCups.fragments.cups,
    cupSeason: AppShowEventCupSeasons.fragments.cupSeason
  },
  created() {
    switch (this.event.status) {
      case "draft":
      case "proposed":
      case "published":
      case "declined":
        this.component = AppShowEventCups;
        this.cups = this.event?.cups ?? [];
        return;
      case "schedule_proposed":
      case "schedule_declined":
      case "registration_open":
      case "registration_closed":
      case "event_running":
      case "event_ended":
      case "results_published":
      case "closed":
        this.component = AppShowEventCupSeasons;
        this.cups = uniq(
          (this.event?.competitions ?? [])
            .map(competition => competition.cupSeasons)
            .flat()
            .filter(Boolean)
        );
        return;
    }
  }
};
</script>
